
'use strict';
define([
    'angular',
    'modules/settings/businessInfo/businessInfo.controller'
],function(angular,BusinesInfoCtrl){
    var app=angular.module('settings.businessInfo', []);
    app.controller('BusinesInfoCtrl',BusinesInfoCtrl);
    return app;
});